/*
Sohel  12/19/2022 3075154998 Added data manager Screen Stepper

*/
import { Button, makeStyles, Stepper, StepLabel, Step } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import reusableInputStyles from '../../../components/InputStyles';
import { ArrowBack } from '@material-ui/icons';
import StepConnector from '@material-ui/core/StepConnector';
import { withStyles } from '@material-ui/core/styles';
import DMBasicInfo from './DMBasicInfo';
import CommonConfig from './CommonConfig';
import { useDispatch, useSelector } from 'react-redux';
import useUnsavedChangesWarning from '../../../util/CustomHooks';
import { setAlertData } from '../../../redux/reducers/UnsavedChangesAlertReducer';
import { fetchSelectedFieldsData } from '../../../redux/reducers/EDI';
import PageLoader from '../../../components/PageLoader';
import NumberStepIcon from '../../../components/customStepIcon';
import SelectField from './Fields';
import FilterCriteria from './FilterCriteria';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const AddDataManager = ({ setValue, exportManager, editExisting, DataManagerAccess }) => {
  const stepperClasses = useStyles();
  const classes = reusableInputStyles();
  // const [steps, setSteps] = useState([
  //   'Basic Info',
  //   'Common Config',
  //   'Select Fields',
  //   'Filter Criteria',
  // ]);
  const steps = ['Basic Info', 'Common Config', 'Select Fields', 'Filter Criteria'];
  const dispatch = useDispatch();
  const { onDirty, onPristine } = useUnsavedChangesWarning();
  const showAlertRef = useRef(false);
  const [activeStep, setActiveStep] = useState(0);
  const [enabledFilters, enableFilterStep] = useState(false);
  const { basicInfoData, selectedProcessorFields } = useSelector(({ ediExport }) => ediExport);
  // const [loading, setIsLoading] = useState(false);
  const loading = false;

  useEffect(() => {
    if (basicInfoData?.exportCode) {
      dispatch(fetchSelectedFieldsData(basicInfoData?.exportCode, 'ediExport'));
    }
  }, [basicInfoData]);

  const handleNext = (value) => {
    setActiveStep((prevActiveStep) => (value ? Number(value) + 1 : prevActiveStep + 1));
  };

  useEffect(() => {
    enableFilterStep(selectedProcessorFields?.dMRecordEntityList?.length > 0);
  }, [selectedProcessorFields]);

  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <DMBasicInfo
          activeStep={activeStep}
          handleNext={handleNext}
          setActiveStep={setActiveStep}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 1:
      return (
        <CommonConfig
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          handleNext={handleNext}
          handleBack={handleBack}
          setValue={setValue}
          {...alertProps}
        />
      );
    case 2:
      return (
        <SelectField
          handleBack={handleBack}
          handleNext={handleNext}
          exportManager={true}
          editExisting={editExisting}
          DataManagerAccess={DataManagerAccess}
          {...alertProps}
        />
      );
    case 3:
      return (
        <FilterCriteria
          handleBack={handleBack}
          handleNext={handleNext}
          exportManagerRecord={true}
          setValue={setValue}
          isDataManager={true}
          editExisting={editExisting}
          DataManagerAccess={DataManagerAccess}
          {...alertProps}
        />
      );
    }
  };
  return (
    <>
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {'Back to EDI Export'}
        </Button>
      </div>

      <div className={classes.root} style={{ border: '1px solid #cfcfcf' }}>
        <Stepper activeStep={activeStep} connector={<QontoConnector />}>
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={index === 3 && !enabledFilters ? false : true}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (index === 3 && !enabledFilters) {
                  return;
                }
                if (index < activeStep) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                } else if (index > activeStep) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                }
              }}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === index ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{ padding: '1.2rem 0.5rem' }}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      {loading && <PageLoader />}
    </>
  );
};

export default AddDataManager;
